export default function isPostMessageSupported() {
  return typeof window.top.postMessage !== 'undefined';
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/isPostMessageSupported.js
 **/